import _every from 'lodash/every';
import {
	ONBOARDING_EMAIL_INVALID,
	ONBOARDING_FIRSTNAME_INVALID,
	ONBOARDING_FIRSTNAME_TOO_LONG,
	ONBOARDING_LASTNAME_INVALID,
	ONBOARDING_LASTNAME_TOO_LONG,
} from '../../../constants/Copy';
import { validate as validators } from '../../../helpers/validation';

export const validateNames = (values) => {
	if (!values.firstName) {
		return { firstName: ONBOARDING_FIRSTNAME_INVALID };
	}
	if (!values.lastName) {
		return { lastName: ONBOARDING_LASTNAME_INVALID };
	}
	if (!validators.name(values.firstName)) {
		return { firstName: ONBOARDING_FIRSTNAME_TOO_LONG };
	}
	if (!validators.name(values.lastName)) {
		return { lastName: ONBOARDING_LASTNAME_TOO_LONG };
	}
};

export const validateEmail = (values) => {
	if (!validators.email(values.email)) {
		return { email: ONBOARDING_EMAIL_INVALID };
	}
	return null;
};

export const hasFormValues = (formValues, ...fields) => {
	return _every(fields, (field) => formValues && formValues[field]);
};
